import React, { useContext, useEffect, useState } from "react";
import { submitVote } from "../../api/MeetingApi";
import { MeetingStatuses } from "../../data/MeetingStatus";
import { SLinkContext } from "../../state/context";
import { toast } from "../../common/notify";
import { Button, Modal } from "react-bootstrap";
import { Item } from "../../data/ItemOfBusiness";
import { ApiStatus } from "../../api/ApiUtilities";
import { logoutAction } from "../../state/actions";
import { UserHouses } from "../../data/User";
import { votingHouseLabel } from "../meetingcommon/MeetingStatusBanner";

interface VotingButtonsProps {
  item: Item | null;
  meetingStatus: string;
}

function VotingButtons({ item, meetingStatus }: VotingButtonsProps) {
  const { state, dispatch } = useContext(SLinkContext);
  const [submited, setSubmited] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [vote, setVote] = useState("");
  const [showVoteConfirmation, setShowVoteConfirmation] = useState(false);
  const [startSeconds, setStartSeconds] = useState(0);
  const [time, setTime] = useState("");
  const [canVote, setCanVote] = useState(false);

  const userHasHouse = state.user?.house !== "";

  useEffect(() => {
    setSubmited(false);
    setSubmiting(false);
    setVote("");
    setShowVoteConfirmation(false);
    setTime("");
    setStartSeconds(Math.abs(Math.floor((new Date(item?.voteRequestedTime ?? new Date()).getTime() - new Date().getTime()) / 1000)));
    setCanVote(
      state.user?.house !== "" &&
        (state.meetingStatus?.currentItem?.votingHouse === "" ||
          (state.meetingStatus?.currentItem?.votingHouse === UserHouses.Lay && state.user?.house === UserHouses.Lay) ||
          (state.meetingStatus?.currentItem?.votingHouse === UserHouses.Clergy && (state.user?.house === UserHouses.Clergy || state.user?.house === UserHouses.Bishops)))
    );
  }, [item?.subId, item?.voteRequestedTime, meetingStatus, state.meetingStatus?.currentItem?.votingHouse, state.user?.house]);

  useEffect(() => {
    let addSecs = 0;
    const id = setInterval(() => {
      var secs = startSeconds + addSecs;
      addSecs++;
      setTime(Math.floor(secs / 60) + ":" + (secs % 60).toString().padStart(2, "0"));
    }, 1000);
    return () => clearInterval(id);
  }, [meetingStatus, startSeconds]);

  function clickVote(response: string) {
    setVote(response);
    setShowVoteConfirmation(true);
  }
  function cancelVote() {
    setVote("");
    setShowVoteConfirmation(false);
  }
  function confirmVote() {
    setSubmiting(true);
    submitVote(vote)
      .then((response) => {
        if (response.status === ApiStatus.Unauthorised) {
          dispatch(logoutAction());
        }
        if (response.status === ApiStatus.Ok) {
          setSubmited(true);
          toast.success("Vote submitted successfully");
        } else {
          toast.error(`Error submitting vote, please try again (${response.message} - ${response.data})`);
        }
      })
      .catch((error: Error) => {
        toast.error(`Vote was not able to be submitted (${error.message})`);
      })
      .finally(() => {
        setSubmiting(false);
        setShowVoteConfirmation(false);
      });
  }

  if (meetingStatus !== MeetingStatuses.Voting) {
    return <></>;
  }

  return (
    <>
      <div className="sl-vote-bar sticky-top">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          <span className="sl-vote-open-chip">
            <span className="sl-pulse" aria-hidden="true"></span>
            Voting open
          </span>
          <span className="fw-bold">{item?.heading}</span>
          <span className="text-muted">({item?.type})</span>
          <span className="ms-auto sl-vote-timer" title="Time since voting opened">
            {time}
          </span>
        </div>
        {canVote ? (
          submited ? (
            <div className="sl-vote-recorded" role="status">
              <span className="sl-vote-glyph" aria-hidden="true">
                ✓
              </span>
              <span>
                Your vote has been recorded: <strong>{vote}</strong>
              </span>
            </div>
          ) : (
            <div className="sl-vote-buttons">
              <button type="button" className="btn sl-vote-btn sl-vote-btn-for" disabled={submiting} onClick={() => clickVote("For")}>
                <span className="sl-vote-glyph" aria-hidden="true">
                  ✓
                </span>
                For
              </button>
              <button type="button" className="btn sl-vote-btn sl-vote-btn-against" disabled={submiting} onClick={() => clickVote("Against")}>
                <span className="sl-vote-glyph" aria-hidden="true">
                  ✕
                </span>
                Against
              </button>
              <button type="button" className="btn sl-vote-btn sl-vote-btn-abstain" disabled={submiting} onClick={() => clickVote("Abstain")}>
                <span className="sl-vote-glyph" aria-hidden="true">
                  —
                </span>
                Abstain
              </button>
            </div>
          )
        ) : (
          <div className="sl-vote-blocked" role="status">
            {userHasHouse
              ? `Voting is currently open for the ${votingHouseLabel(state.meetingStatus?.currentItem?.votingHouse)}.`
              : "Your account is not able to vote in this meeting."}
          </div>
        )}
      </div>
      <Modal show={showVoteConfirmation} onHide={cancelVote} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm your vote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-2">{item?.heading}</p>
          <p className="fs-5 mb-0">
            Vote <strong>{vote}</strong> — are you sure?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className="me-auto" onClick={cancelVote} disabled={submiting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmVote} disabled={submiting}>
            {submiting ? "Please wait..." : `Submit ${vote} vote`}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VotingButtons;
